import { connect } from 'react-redux'
import GridLayout from 'pages/dashboard/GridLayout'
import {
  setDashboardIsLoaded
} from 'redux/actions'

const mapStateToProps = (state, ownProps) => ({
  isLogged: state.user.isLogged,
  cmsCtx: state.cms.ctx,
  aol: ownProps.aol
})

const mapDispatchToProps = dispatch => ({
  setDashboardIsLoaded: isLoaded => dispatch(setDashboardIsLoaded(isLoaded))
})

export default connect(mapStateToProps, mapDispatchToProps)(GridLayout)
